import * as React from 'react';
import {
    Box,
    TextField,
    Typography,
    Button, FormControl,
    FormLabel, Grid, Container
} from "@mui/material";

import ReviewResultLink from './ReviewResultLink'
import {useState} from "react";
import {defaultShortLinkDto, ShortLinkDto} from "../types/types";
import {createLink} from "../api/controllers/web-controller";
import FormControlContext from "@mui/material/FormControl/FormControlContext";

interface RequestLinkProps {
    reviewElement: Number
}

const RequestLink = (props: RequestLinkProps) => {
    const {reviewElement} = props;

    const [link, setLink] = React.useState<string>('');
    const [shortLink, setShortLink] = useState<ShortLinkDto>(defaultShortLinkDto);
    const [visibleTypography, setVisibleTypography] = React.useState(true);
    const [errorURL, setErrorURL] = React.useState(true);

    /**
     * Проверка input на ссылку
     */
    const handlerSubmit = () => {
        let reg = /(http\:\/\/)|(https\:\/\/)|(file\:\/\/\/)|(ftp\:\/\/)/img;
        if (!reg.test(link)) {
            setErrorURL(false);
        } else { // когда все ок
            createLink({url: link}).then(response => {
                setShortLink(response.data);
                setErrorURL(true);
                setVisibleTypography(false);
            }).catch(err => {
                console.log(err);

                // TODO: Удалить когда будет рабоать сервер

                setVisibleTypography(false);
                alert("Произошла ошибка. Мы уже чиним =)");
            });
        }
    }

    /**
     * Отображение в переменной значения value input
     * @param elm input
     */
    const changeLink = (elm: any) => {
        setLink(elm.target.value);
    }

    return (
        <>
            <Container>
                <Typography sx={{pb: 2, fontSize: {xs: 18, sm: 30}}}>Сократите URL</Typography>
                <Grid container spacing={2} sx={{mt: 2}}>
                    <Grid item md={10} sm={12}>
                        <TextField
                            id="url"
                            onChange={changeLink}
                            label="Вставте ссылку сюда"
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                    <Grid item md={2} sm={12}>
                        <Button sx={{mt: 0, height: 56}} fullWidth={true} size={"large"} variant="contained"
                                onClick={handlerSubmit}>Создать</Button>
                    </Grid>
                    <Typography sx={{color: 'red', fontSize: 17}} hidden={errorURL}>Это не ссылка, введите ссылку</Typography>
                </Grid>
            </Container>
            <Container>
                <ReviewResultLink shortLink={shortLink.shortLink} visibleResult={visibleTypography}/>
            </Container>
        </>
    )
}

export default RequestLink;